import { EducationalHub } from "../../../types/EducationalHub";
import { TypeUserData } from "../../../types/TypeUsers";
import { MultiLangText } from "../../../utils/profileDiffUtils";

export const getTextByLang = (
  values: MultiLangText[] | undefined,
  preferred = "en",
): string => {
  if (!values || values.length === 0) return "";
  return (
    values.find((item) => item.language === preferred)?.text ||
    values[0]?.text ||
    ""
  );
};

export const getUserName = (user?: Partial<TypeUserData>): string => {
  if (!user) return "";
  const firstName = Array.isArray(user.name)
    ? getTextByLang(user.name)
    : user.name || "";
  const lastName = Array.isArray(user.surname)
    ? getTextByLang(user.surname)
    : user.surname || "";
  return `${firstName} ${lastName}`.trim();
};

export const getUserLabel = (user?: Partial<TypeUserData>): string =>
  getUserName(user) || user?.email || "Unknown user";

export const getHubTitle = (hub: EducationalHub): string =>
  getTextByLang(hub.title, hub.createdBy?.selectedLanguage) ||
  "Untitled Educational Hub";

export const formatHubDate = (dateString?: string): string => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const getEndOfSelectedDate = (date: string): Date => {
  const dateTo = new Date(date);
  dateTo.setUTCHours(23, 59, 59, 999);
  return dateTo;
};

export const normalizeHubSubdomain = (value: string): string =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 20);
